import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Image from "next/image";
import React, { useMemo, useState } from "react";
import { useBooks } from "@/components/Books/Order";
import { ExtraResourceNew } from "@/components/Product/ExtraResourceNew";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { Link as ScrollLink } from "react-scroll";
import { isBooksProduct } from "src/api/booksProducts";
import { Title } from "@/components/Product/Handout/index";
import Review from "@/components/Reviews/Detail";
import ProductDetailTerms from "@/modules/products/components/ProductDetail/ProductDetailTerms";
import detailInfoList from "@/modules/products/components/ProductDetail/detailInfoList";
import { Box, Divider, Typography, styled } from "@mui/material";
import Link from "next/link";
import useHandoutProductStore from "../../../store/relatedProduct";
import { BookInfoTab, ContentsTab, DetailTab, PreviewTab, RefundTab, StyledAnchor } from "./HandoutProductDetailContent.style";
var LinkTab;
(function(LinkTab) {
    LinkTab["contents"] = "contents";
    LinkTab["author"] = "author";
    LinkTab["preview"] = "preview";
    LinkTab["detail"] = "detail";
    LinkTab["refund"] = "refund";
    LinkTab["book"] = "book";
    LinkTab["bookShipRefund"] = "bookShipRefund";
    LinkTab["review"] = "review";
    LinkTab["qna"] = "qna";
})(LinkTab || (LinkTab = {}));
export const HandoutProductDetailContent = (param)=>{
    let { product  } = param;
    const isBooks = isBooksProduct(product);
    const { isBooks: isAladinbook  } = useBooks();
    const isEbook = isBooks && !isAladinbook;
    const productType = isBooks ? product.productType : product.source_type;
    const { hasReview  } = useHandoutProductStore((state)=>({
            hasReview: state.hasReview
        }));
    const { publisherName  } = product;
    const source = isBooks ? product : product.source;
    const { sub_items  } = source;
    const { images  } = source;
    const previewImages = images === null || images === void 0 ? void 0 : images.previews;
    const promotionImages = (images === null || images === void 0 ? void 0 : images.promotions) ? Array.isArray(images === null || images === void 0 ? void 0 : images.promotions) && (images === null || images === void 0 ? void 0 : images.promotions.slice().sort((a, b)=>a.order - b.order)) : [];
    const hasSubItems = useMemo(()=>{
        return sub_items && sub_items.length > 0;
    }, [
        sub_items
    ]);
    const { width  } = useWindowDimensions();
    const isMobile = width < 1200;
    const [scrollLinkOptions] = useState({
        activeClass: "active",
        smooth: true,
        offset: isMobile ? -200 : -150,
        spy: true
    });
    const isBrand = isBooks ? false : product.brandName;
    const TabList = [
        {
            key: "detail",
            title: "자료정보",
            render: true
        },
        {
            key: "preview",
            title: "샘플 보기",
            render: !isBooks
        },
        {
            key: "review",
            title: "후기",
            render: hasReview
        },
        {
            key: "refund",
            title: "환불기준",
            render: !isBooks || isEbook
        },
        {
            key: "qna",
            title: "Q&A",
            render: isBrand
        }
    ];
    return /*#__PURE__*/ _jsxs(ProductDetailArticle, {
        children: [
            /*#__PURE__*/ _jsx(StyledAnchor, {
                children: TabList.map((tab, index)=>{
                    return tab.render ? /*#__PURE__*/ _jsx("li", {
                        children: tab.key === "qna" && isBrand ? /*#__PURE__*/ _jsx(Link, {
                            href: "/@".concat(product.brandName, "/qna"),
                            onClick: ()=>{
                                //mx-187
                                mixpanelEvent("Product Detail Page Tab Clicked", {
                                    "Tab Name": tab.title
                                });
                            },
                            children: tab.title
                        }) : /*#__PURE__*/ _jsx(ScrollLink, {
                            to: tab.key,
                            ...scrollLinkOptions,
                            onClick: ()=>mixpanelEvent("Product Detail Page Tab Clicked", {
                                    "Tab Name": tab.title
                                }),
                            children: tab.title
                        })
                    }, "bottom-tab-".concat(index)) : null;
                })
            }),
            /*#__PURE__*/ _jsxs(ScrollSection, {
                children: [
                    /*#__PURE__*/ _jsxs(DetailTab, {
                        name: "detail",
                        children: [
                            /*#__PURE__*/ _jsx(Title, {
                                children: "자료 정보"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "wrapper info-wrapper",
                                children: /*#__PURE__*/ _jsx("ul", {
                                    children: detailInfoList(product, isBooks ? product.publisher : publisherName).filter((item)=>item.value).map((item, index)=>{
                                        return /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                /*#__PURE__*/ _jsx(Typography, {
                                                    variant: "body1",
                                                    color: "text.secondary",
                                                    children: item.type
                                                }),
                                                /*#__PURE__*/ _jsx(Typography, {
                                                    variant: "body1",
                                                    color: "text.primary",
                                                    children: item.value
                                                })
                                            ]
                                        }, "detail-info-".concat(index));
                                    })
                                })
                            }),
                            (product === null || product === void 0 ? void 0 : product.description) && /*#__PURE__*/ _jsx(Typography, {
                                variant: "body1",
                                color: "text.secondary",
                                sx: (theme)=>({
                                        padding: "20px",
                                        backgroundColor: theme.palette.grey[0],
                                        borderRadius: "6px",
                                        marginTop: "12px",
                                        whiteSpace: "pre-wrap"
                                    }),
                                children: product.description
                            }),
                            promotionImages && promotionImages.length > 0 && /*#__PURE__*/ _jsx(Box, {
                                marginTop: 1.5,
                                children: promotionImages.map((image, index)=>{
                                    return /*#__PURE__*/ _jsx(Image, {
                                        alt: "".concat(product.title, "_promotion"),
                                        width: 3000,
                                        height: 6000,
                                        src: image.url,
                                        sizes: "(max-width: 1080px) 100vw, 825px"
                                    }, "promotion-image-" + index);
                                })
                            })
                        ]
                    }),
                    isEbook && /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx("img", {
                            src: "/static/assets/".concat(isMobile ? "Mobile" : "PC", "-image-goodnote.jpg"),
                            alt: "ebook-promotion-img"
                        })
                    }),
                    hasSubItems && /*#__PURE__*/ _jsxs(ContentsTab, {
                        name: "contents",
                        children: [
                            /*#__PURE__*/ _jsx("h3", {
                                children: "포함된 컨텐츠"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                children: sub_items.map((subItem, index)=>{
                                    return /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            /*#__PURE__*/ _jsx(ExtraResourceNew, {
                                                type: subItem.type
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                children: subItem.title
                                            })
                                        ]
                                    }, "sub-item-".concat(index));
                                })
                            })
                        ]
                    }),
                    isBooks && (product.introduction || product.tableOfContents) && /*#__PURE__*/ _jsxs(BookInfoTab, {
                        name: "book",
                        children: [
                            /*#__PURE__*/ _jsx("h3", {
                                children: "도서 정보"
                            }),
                            product.introduction && /*#__PURE__*/ _jsxs("div", {
                                className: "info-cell",
                                children: [
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "title",
                                        children: "책소개"
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "content",
                                        dangerouslySetInnerHTML: {
                                            __html: product.introduction
                                        }
                                    })
                                ]
                            }),
                            product.tableOfContents && /*#__PURE__*/ _jsxs("div", {
                                className: "info-cell",
                                children: [
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "title",
                                        children: "목차"
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "content",
                                        dangerouslySetInnerHTML: {
                                            __html: product.tableOfContents
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Divider, {}),
                    previewImages && /*#__PURE__*/ _jsxs(PreviewTab, {
                        name: "preview",
                        children: [
                            /*#__PURE__*/ _jsx(Title, {
                                children: "샘플 보기"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                children: previewImages.sort((a, b)=>a.page_num - b.page_num).map((image, index)=>{
                                    return /*#__PURE__*/ _jsx(Image, {
                                        alt: "".concat(product.title, "_preview_").concat(image.page_num),
                                        width: 3000,
                                        height: 6000,
                                        src: image.url,
                                        sizes: "(max-width: 1080px) 100vw, 825px"
                                    }, "preview-image-" + index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Divider, {}),
                    hasReview && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(DetailTab, {
                                name: "review",
                                children: /*#__PURE__*/ _jsx(Review, {
                                    productItem: product
                                })
                            }),
                            /*#__PURE__*/ _jsx(Divider, {})
                        ]
                    }),
                    /*#__PURE__*/ _jsx(RefundTab, {
                        name: "refund",
                        children: /*#__PURE__*/ _jsx(ProductDetailTerms, {
                            productType: productType
                        })
                    })
                ]
            })
        ]
    });
};
const ProductDetailArticle = styled("article")((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        flexDirection: "column",
        gap: "48px",
        [theme.breakpoints.down("sm")]: {
            gap: "32px"
        }
    };
});
const ScrollSection = styled("section")((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        flexDirection: "column",
        gap: "48px",
        [theme.breakpoints.down("lg")]: {
            padding: "0 32px"
        },
        [theme.breakpoints.down("sm")]: {
            padding: "0 16px"
        }
    };
});
